import classNames from 'classnames'
import React from 'react'
import Tab from './Tab'
import styles from './styles.module.scss'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

type TabInfo = {
  icon: IconDefinition
  location: string
  tip: string
}

type Props = {
  className?: string
  tabs?: TabInfo[]
}

export const ExternalLinkBar: React.FC<Props> = ({ className, tabs }) => {
  return (
    <div className={classNames(styles.container, className)}>
      {tabs?.map((tab, i) => (
        <Tab key={`TAB_${i}`} {...tab} />
      ))}
    </div>
  )
}
